import { random } from 'lodash';

export const recipes = {
  freshCoffee: 'กาแฟสด',
  authenticCoffee: 'กาแฟโบราณ',
  iceTea: 'ชาเย็น',
  lemonTea: 'ชามะนาว',
  coco: 'โกโก้',
  coconutRaspberrySmoothie: 'Coconut Raspberry Smoothie',
  coffee: 'Coffee',
  creamyHotCocoa: 'Creamy Hot Cocoa',
  frozenStrawberryMargarita: 'Frozen Strawberry Margarita',
  greenTeaLate: 'Green Tea Late',
  lemonade: 'Lemonade',
  milkTea: 'Milk Tea',
  mocha: 'Mocha',
  sparklingPunch: 'Sparkling Punch',
  zLemonade2: 'Lemonade#2',
};

export const recipeOptions = [
  recipes.freshCoffee,
  recipes.authenticCoffee,
  recipes.iceTea,
  recipes.lemonTea,
  recipes.coco,
  recipes.coconutRaspberrySmoothie,
  recipes.coffee,
  recipes.creamyHotCocoa,
  recipes.frozenStrawberryMargarita,
  recipes.greenTeaLate,
  recipes.lemonade,
  recipes.milkTea,
  recipes.mocha,
  recipes.sparklingPunch,
  recipes.zLemonade2,
];

function getDummyRecipe(recipeName) {
  let ingredients = [];

  for (let i = 1; i <= random(1, 10); i++) {
    ingredients.push({
      // name: `วัตถุดิบ #${i} สำหรับ ${recipeName}`,
      name: `วัตถุดิบ #${i}`,
      unit: 'หน่วย',
      amountPerPackage: '100',
      costPerPackage: '100',
      amountPerformula: '10',
    });
  }
  return ingredients;
}

export const dummyRecipe = {
  recipeName: 'Dummy Recipe',
  ingredients: [
    {
      name: 'วัตถุดิบ #1',
      unit: 'หน่วย',
      amountPerPackage: '100',
      costPerPackage: '100',
      amountPerformula: '10',
    },
    {
      name: 'วัตถุดิบ #2',
      unit: 'หน่วย',
      amountPerPackage: '100',
      costPerPackage: '100',
      amountPerformula: '10',
    },
    {
      name: 'วัตถุดิบ #3',
      unit: 'หน่วย',
      amountPerPackage: '100',
      costPerPackage: '100',
      amountPerformula: '10',
    },
  ],
};

export const initialCostValues = [
  {
    recipeName: recipes.freshCoffee,
    ingredients: [
      {
        name: 'ผงกาแฟ',
        unit: 'กรัม',
        amountPerPackage: '500',
        costPerPackage: '100',
        amountPerformula: '100',
      },
      {
        name: 'นมสด',
        unit: 'ออนซ์',
        amountPerPackage: '1000',
        costPerPackage: '50',
        amountPerformula: '20',
      },
      {
        name: 'แก้ว',
        unit: 'ใบ',
        amountPerPackage: '50',
        costPerPackage: '50',
        amountPerformula: '1',
      },
    ],
  },
  {
    recipeName: recipes.authenticCoffee,
    ingredients: [
      {
        name: 'ผงกาแฟ',
        unit: 'กรัม',
        amountPerPackage: '500',
        costPerPackage: '100',
        amountPerformula: '100',
      },
      {
        name: 'นมสด',
        unit: 'ออนซ์',
        amountPerPackage: '1000',
        costPerPackage: '50',
        amountPerformula: '20',
      },
      {
        name: 'แก้ว',
        unit: 'ใบ',
        amountPerPackage: '50',
        costPerPackage: '50',
        amountPerformula: '1',
      },
    ],
  },
  {
    recipeName: recipes.iceTea,
    ingredients: [
      {
        name: 'ไอเท็ม #1',
        unit: 'หน่วย',
        amountPerPackage: '500',
        costPerPackage: '100',
        amountPerformula: '100',
      },
      {
        name: 'ไอเท็ม #2',
        unit: 'หน่วย',
        amountPerPackage: '1000',
        costPerPackage: '50',
        amountPerformula: '20',
      },
      {
        name: 'ไอเท็ม #3',
        unit: 'หน่วย',
        amountPerPackage: '50',
        costPerPackage: '50',
        amountPerformula: '1',
      },
    ],
  },
  {
    recipeName: recipes.lemonTea,
    ingredients: [
      {
        name: 'ไอเท็ม #1',
        unit: 'หน่วย',
        amountPerPackage: '500',
        costPerPackage: '100',
        amountPerformula: '100',
      },
      {
        name: 'ไอเท็ม #2',
        unit: 'หน่วย',
        amountPerPackage: '1000',
        costPerPackage: '50',
        amountPerformula: '20',
      },
      {
        name: 'ไอเท็ม #3',
        unit: 'หน่วย',
        amountPerPackage: '50',
        costPerPackage: '50',
        amountPerformula: '1',
      },
    ],
  },
  {
    recipeName: recipes.coco,
    ingredients: [
      {
        name: 'ไอเท็ม #1',
        unit: 'หน่วย',
        amountPerPackage: '500',
        costPerPackage: '100',
        amountPerformula: '100',
      },
      {
        name: 'ไอเท็ม #2',
        unit: 'หน่วย',
        amountPerPackage: '1000',
        costPerPackage: '50',
        amountPerformula: '20',
      },
      {
        name: 'ไอเท็ม #3',
        unit: 'หน่วย',
        amountPerPackage: '50',
        costPerPackage: '50',
        amountPerformula: '1',
      },
    ],
  },
  {
    recipeName: recipes.coconutRaspberrySmoothie,
    ingredients: [
      {
        name: 'Coconut milk',
        unit: 'oz',
        amountPerPackage: '500',
        costPerPackage: '100',
        amountPerformula: '100',
      },
      {
        name: 'Frozen raspberries',
        unit: 'gram',
        amountPerPackage: '1000',
        costPerPackage: '200',
        amountPerformula: '20',
      },
      {
        name: 'Orange juice',
        unit: 'oz',
        amountPerPackage: '1000',
        costPerPackage: '200',
        amountPerformula: '20',
      },
      {
        name: 'Honey',
        unit: 'oz',
        amountPerPackage: '200',
        costPerPackage: '32',
        amountPerformula: '1',
      },
      {
        name: 'Cup',
        unit: 'cup',
        amountPerPackage: '50',
        costPerPackage: '50',
        amountPerformula: '1',
      },
    ],
  },
  {
    recipeName: recipes.coffee,
    ingredients: [
      {
        name: 'Coffee',
        unit: 'gram',
        amountPerPackage: '500',
        costPerPackage: '100',
        amountPerformula: '50',
      },
      {
        name: 'Milk',
        unit: 'oz',
        amountPerPackage: '1000',
        costPerPackage: '200',
        amountPerformula: '20',
      },
      {
        name: 'Cup',
        unit: 'cup',
        amountPerPackage: '50',
        costPerPackage: '50',
        amountPerformula: '1',
      },
    ],
  },
  {
    recipeName: recipes.creamyHotCocoa,
    ingredients: getDummyRecipe(recipes.creamyHotCocoa),
  },
  {
    recipeName: recipes.frozenStrawberryMargarita,
    ingredients: getDummyRecipe(recipes.frozenStrawberryMargarita),
  },
  {
    recipeName: recipes.greenTeaLate,
    ingredients: [
      {
        name: 'Green tea powder',
        unit: 'gram',
        amountPerPackage: '500',
        costPerPackage: '100',
        amountPerformula: '20',
      },
      {
        name: 'Soy milk',
        unit: 'oz',
        amountPerPackage: '1000',
        costPerPackage: '200',
        amountPerformula: '80',
      },
      {
        name: 'White sugar',
        unit: 'gram',
        amountPerPackage: '50',
        costPerPackage: '50',
        amountPerformula: '5',
      },
      {
        name: 'Cup',
        unit: 'cup',
        amountPerPackage: '50',
        costPerPackage: '50',
        amountPerformula: '1',
      },
    ],
  },
  {
    recipeName: recipes.lemonade,
    ingredients: getDummyRecipe(recipes.lemonade),
  },
  {
    recipeName: recipes.milkTea,
    ingredients: [
      {
        name: 'Tea powder',
        unit: 'gram',
        amountPerPackage: '500',
        costPerPackage: '100',
        amountPerformula: '50',
      },
      {
        name: 'Condense milk',
        unit: 'gram',
        amountPerPackage: '1000',
        costPerPackage: '200',
        amountPerformula: '20',
      },
      {
        name: 'Cup',
        unit: 'cup',
        amountPerPackage: '50',
        costPerPackage: '50',
        amountPerformula: '1',
      },
    ],
  },
  {
    recipeName: recipes.sparklingPunch,
    ingredients: getDummyRecipe(recipes.sparklingPunch),
  },
  {
    recipeName: recipes.mocha,
    ingredients: [
      {
        name: 'Ground coffee',
        unit: 'gram',
        amountPerPackage: '500',
        costPerPackage: '100',
        amountPerformula: '30',
      },
      {
        name: 'Whole milk',
        unit: 'oz',
        amountPerPackage: '1000',
        costPerPackage: '200',
        amountPerformula: '20',
      },
      {
        name: 'Heavy cream',
        unit: 'oz',
        amountPerPackage: '1000',
        costPerPackage: '200',
        amountPerformula: '5',
      },
      {
        name: 'Cocoa powder',
        unit: 'gram',
        amountPerPackage: '200',
        costPerPackage: '30',
        amountPerformula: '5',
      },
      {
        name: 'Cup',
        unit: 'cup',
        amountPerPackage: '50',
        costPerPackage: '50',
        amountPerformula: '1',
      },
    ],
  },
  {
    recipeName: recipes.zLemonade2,
    ingredients: getDummyRecipe(recipes.zLemonade2),
  },
];
